import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Observable, take } from "rxjs";
import {
  CustomDetailComponent,
  DataService,
  NotificationService,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import {
  GetEventListSettingsDocument,
  UpdateEventListSettingsDocument,
} from "src/generated-gql/graphql";

/**
 * Event list card (embedded on the Global Settings page). Controls how long an
 * event stays in the admin event list after it ends.
 *
 * The value lives on a GlobalSettings custom field marked `internal` — read via
 * the dedicated query and saved via a dedicated mutation, mirroring the two
 * cards next to it. The standard settings form reports success but does not
 * persist these fields.
 */
@Component({
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./event-list-settings.component.html",
})
export class EventListSettingsComponent
  implements CustomDetailComponent, OnInit
{
  entity$: Observable<any>;
  detailForm: FormGroup;

  hideEndedEventsAfterDays = 0;
  saving = false;

  constructor(
    private dataService: DataService,
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.dataService
      .query(GetEventListSettingsDocument, {}, "network-only")
      .single$.pipe(take(1))
      .subscribe((res) => {
        const s = res?.eventListSettings;
        if (s) {
          this.hideEndedEventsAfterDays = s.hideEndedEventsAfterDays ?? 0;
          this.cdr.markForCheck();
        }
      });
  }

  save(): void {
    this.saving = true;
    this.dataService
      .mutate(UpdateEventListSettingsDocument, {
        hideEndedEventsAfterDays: Math.max(
          0,
          Number(this.hideEndedEventsAfterDays) || 0
        ),
      })
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.saving = false;
          this.notificationService.success("Event list settings updated");
          this.cdr.markForCheck();
        },
        error: () => {
          this.saving = false;
          this.cdr.markForCheck();
        },
      });
  }
}
